/**
 * SlingoLang.ts
 */
export class SlingoLang {
}
SlingoLang.LOADER_PLAY_BUTTON = "GameLang.LOADER_PLAY_BUTTON";
SlingoLang.LOADER_GUIDE_BODY = "GameLang.LOADER_GUIDE_BODY_";
SlingoLang.SPIN_BUTTON = "GameLang.SPIN_BUTTON";
SlingoLang.FREE_SPIN_BUTTON = "GameLang.FREE_SPIN_BUTTON";
SlingoLang.START_GAME_BUTTON = "GameLang.START_GAME_BUTTON";
SlingoLang.PURCHASE_SPIN_BUTTON = "GameLang.PURCHASE_SPIN_BUTTON";
SlingoLang.COLLECT_BUTTON = "GameLang.COLLECT_BUTTON";
SlingoLang.END_GAME_BUTTON = "GameLang.END_GAME_BUTTON";
SlingoLang.SLINGO_SHORT = "GameLang.SLINGO_SHORT_";
SlingoLang.SLINGO = "GameLang.SLINGO_";
SlingoLang.BALANCE = "GameLang.BALANCE";
SlingoLang.BACK_TO_GAME_BUTTON = "GameLang.BACK_TO_GAME_BUTTON";
SlingoLang.TOTAL_WIN_TITLE = "GameLang.TOTAL_WIN_TITLE";
SlingoLang.BIG_WIN = "GameLang.BIG_WIN";
SlingoLang.BIG_WIN_0 = "GameLang.BIG_WIN_0";
SlingoLang.BIG_WIN_1 = "GameLang.BIG_WIN_1";
SlingoLang.FULL_HOUSE = "GameLang.FULL_HOUSE";
SlingoLang.FULL_HOUSE_0 = "GameLang.FULL_HOUSE_0";
SlingoLang.FULL_HOUSE_1 = "GameLang.FULL_HOUSE_1";
SlingoLang.JOKER_BONUS = "GameLang.JOKER_BONUS";
SlingoLang.RESULTS = "GameLang.RESULTS";
SlingoLang.WIN = "GameLang.WIN";
SlingoLang.WIN_LABEL = "GameLang.WIN_LABEL";
SlingoLang.GAME_OVER = "GameLang.GAME_OVER";
SlingoLang.SLINGO_CELL = "GameLang.SLINGO_CELL";
SlingoLang.JOKER_CELL = "GameLang.JOKER_CELL";
SlingoLang.FREE_SPIN = "GameLang.FREE_SPIN";
SlingoLang.CONTINUE_BUTTON = "GameLang.CONTINUE_BUTTON";
SlingoLang.DONT_SHOW_BUTTON = "GameLang.DONT_SHOW_BUTTON";
SlingoLang.SCATTER = "GameLang.SCATTER";
SlingoLang.SCATTER_0 = "GameLang.SCATTER_0";
SlingoLang.SCATTER_1 = "GameLang.SCATTER_1";
SlingoLang.SCATTER_6 = "GameLang.SCATTER_6";
SlingoLang.DOUBLE = "GameLang.DOUBLE";
SlingoLang.TRIPLE = "GameLang.TRIPLE";
SlingoLang.QUADRUPLE = "GameLang.QUADRUPLE";
SlingoLang.IDLE = "GameLang.IDLE_";
SlingoLang.IDLE_STANDARD_SPIN = "GameLang.IDLE_STANDARD_SPIN_";
SlingoLang.IDLE_FREE_SPIN = "GameLang.IDLE_FREE_SPIN_";
SlingoLang.PURCHASE_SPIN = "GameLang.PURCHASE_SPIN_";
SlingoLang.START_GAME = "GameLang.START_GAME";
SlingoLang.STANDARD_SPIN = "GameLang.STANDARD_SPIN";
SlingoLang.PURCHASED_SPIN = "GameLang.PURCHASED_SPIN";
SlingoLang.REEL_STRIKE_JOKER = "GameLang.REEL_STRIKE_JOKER";
SlingoLang.REEL_STRIKE_SUPER_JOKER = "GameLang.CHOOSE_CELL_SUPER_JOKER_0";
SlingoLang.REEL_STRIKE_DEVIL = "GameLang.REEL_STRIKE_DEVIL_";
SlingoLang.REEL_STRIKE_FREE_SPIN = "GameLang.REEL_STRIKE_FREE_SPIN";
SlingoLang.REEL_STRIKE_BONUS = "GameLang.REEL_STRIKE_BONUS";
SlingoLang.SPIN_RESULT = "GameLang.SPIN_RESULT_";
SlingoLang.CHOOSE_CELL = "GameLang.CHOOSE_CELL_";
SlingoLang.CHOOSE_CELL_JOKER = "GameLang.CHOOSE_CELL_JOKER_";
SlingoLang.CHOOSE_CELL_SUPER_JOKER = "GameLang.CHOOSE_CELL_SUPER_JOKER_";
SlingoLang.SYMBOL_WIN = "GameLang.SYMBOL_WIN_";
SlingoLang.SYMBOL_WIN_JOKER = "_JOKER_";
SlingoLang.SYMBOL_WIN_COIN = "GameLang.SYMBOL_WIN_COIN_";
SlingoLang.DEVIL = "GameLang.DEVIL_";
SlingoLang.CHERUB = "GameLang.CHERUB";
SlingoLang.SLINGO_AWARD = "GameLang.SLINGO_AWARD_";
SlingoLang.SLINGO_COMPLETE = "GameLang.SLINGO_COMPLETE";
SlingoLang.RESULT_NO_WIN = "GameLang.RESULT_NO_WIN_";
SlingoLang.RESULT_WIN_2X = "GameLang.RESULT_WIN_2X";
SlingoLang.RESULT_WIN_7X = "GameLang.RESULT_WIN_7X";
SlingoLang.RESULT_WIN_25X = "GameLang.RESULT_WIN_25X";
SlingoLang.RESULT_FULL_CARD = "GameLang.RESULT_FULL_CARD";
SlingoLang.TOTAL_STAKED_TITLE = "GameLang.TOTAL_STAKED_TITLE";
SlingoLang.BOTTOM_BAR_GAME_ID = "GameLang.BOTTOM_BAR_GAME_ID";
SlingoLang.BOTTOM_BAR_STAKE = "GameLang.BOTTOM_BAR_STAKE";
SlingoLang.BOTTOM_BAR_TOTAL_STAKE = "GameLang.BOTTOM_BAR_TOTAL_STAKE";
SlingoLang.AVAILABLE_WIN = "GameLang.AVAILABLE_WIN";
SlingoLang.LOADER_GUIDE_BODY_3_0 = "GameLang.LOADER_GUIDE_BODY_3_0";
SlingoLang.LOADER_GUIDE_BODY_3_1 = "GameLang.LOADER_GUIDE_BODY_3_1";
SlingoLang.LOADER_GUIDE_BODY_3_2 = "GameLang.LOADER_GUIDE_BODY_3_2";
SlingoLang.RTP_INFO_MESSAGE = "GameLang.RTP_INFO_MESSAGE";
SlingoLang.RTP_PREFIX = "GameLang.RTP_";
SlingoLang.PARAM_SPIN = "{param.spin}";
SlingoLang.PARAM_SPINS = "{param.spins}";
SlingoLang.PARAM_CELLS = "{param.cells}";
SlingoLang.PARAM_SCATTER_5 = "{param.scatter5}";
SlingoLang.PARAM_SCATTER_4 = "{param.scatter4}";
SlingoLang.PARAM_SCATTER_3 = "{param.scatter3}";
SlingoLang.PARAM_AMOUNT = "{param.amount}";
SlingoLang.PARAM_TOTAL = "{param.total}";
SlingoLang.OPTIONS_PAYS = "GameLang.OPTIONS_PAYS";
SlingoLang.PAYTABLE = "GameLang.PAYTABLE";
//# sourceMappingURL=SlingoLang.js.map